import React from 'react';

interface BadgeProps {
  children: React.ReactNode;
  variant?: 'default' | 'veg' | 'nonveg' | 'alcohol' | 'shared' | 'success' | 'warning' | 'error';
  size?: 'sm' | 'md';
  icon?: React.ReactNode;
  className?: string;
}

export const Badge: React.FC<BadgeProps> = ({
  children,
  variant = 'default',
  size = 'md',
  icon,
  className = '',
}) => {
  const variants = {
    default: 'bg-slate-100 text-slate-700',
    veg: 'bg-green-100 text-green-700',
    nonveg: 'bg-orange-100 text-orange-700',
    alcohol: 'bg-purple-100 text-purple-700',
    shared: 'bg-blue-100 text-blue-700',
    success: 'bg-green-100 text-green-700',
    warning: 'bg-amber-100 text-amber-700',
    error: 'bg-red-100 text-red-700',
  };

  const sizes = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2.5 py-1 text-xs',
  };

  return (
    <span
      className={`
        inline-flex items-center gap-1 rounded-full font-medium
        ${variants[variant]}
        ${sizes[size]}
        ${className}
      `}
    >
      {icon}
      {children}
    </span>
  );
};

export default Badge;
